import Select from "react-select";

export default function SearchableColumnSelect({
  value,
  options,
  onChange,
  placeholder = "Select Column",
}) {
  const selectOptions = options.map((c) => ({
    value: c,
    label: c,
  }));

  return (
    <Select
      options={selectOptions}
      value={
        selectOptions.find(
          (o) => o.value === value
        ) || null
      }
      onChange={(selected) =>
        onChange(selected?.value || "")
      }
      placeholder={placeholder}
      isClearable
      styles={{
        option: (base) => ({
          ...base,
          textAlign: "left",
        }),
        singleValue: (base) => ({
          ...base,
          textAlign: "left",
        }),
        placeholder: (base) => ({
          ...base,
          textAlign: "left",
        }),
      }}
    />
  );
}